//import './scfp/scfp-min';
//import './scfp/ev-sc.min';
import $ from 'jquery';
import Notifier from './paywall-notifier';

import {
  CONFIG_NAMESPACE,
  // EVOLOK_SESSION_CHECK_PATH as authorizeUrl,
  GIGYA_READY,
  GIGYA_PRODUCTS_READY,
  PAYWALL_CONTENT,
  READY_PROMISE_NS,
  SET_EVENT
} from './constants';

const app = Voonto.getInstance();

app.on(PAYWALL_CONTENT, () => {
  const config = app.lookup(CONFIG_NAMESPACE);
  // if (config.isNewAnonymousSession && config.isNewAnonymousSession !== 'false') {
  // EV.Sc.init({authorizeUrl});
  // EV.Sc.handleNewSession((result) => {
  //   if (!navigator.cookieEnabled) {
  //     $.extend(config, {
  //       result: result.responseText,
  //       meter:  result.getHeader('X-METER_NAME'),
  //       pid:    result.getHeader('X-USER_ID'),
  //       count:  result.getHeader('X-METER_COUNT'),
  //       max:    result.getHeader('X-METER_MAX'),
  //       viewed: result.getHeader('X-REPEAT_VIEW')
  //     }, {
  //       meterExceeded: result.getHeader('X-METER_EXCEEDED')
  //     });
  //   } else if (!result.allowAccess) {
  //     // FIXME: in this case, scfp is saved and Evolok know it. No need to reload
  //     let url = window.location.href.replace('http://','https://');
  //     window.location.href = url;
  //   }

  //   _notify(app, config);
  // }, (/*error*/) => {
  //   throw Error('[Paywall] EV.Sc.handleNewSession error');
  // }, config.cookie, true);
  // } else {
  // Paywall::Is NOT anonimous session
  _notify(app, config);
  // }
});

//init paywall
if (app.lookup('vocento.config.paywall').enabled) {
  app.trigger(PAYWALL_CONTENT);
} else {
  initialized = true;
}

app.on('voonto:reload', (/* event, element$ */) => {
  app.trigger(PAYWALL_CONTENT);
});

export var initialized = false;

/* private */

function _notify(app, config) {
  if (initialized) {
    app.trigger(SET_EVENT, {
      IDEvolok:              config.pid,
      productoEvolok:        config.meter,
      nPaginasConsumidas:    config.count,
      nPaginasPermitidas:    config.max,
      autorizacionContenido: config.result,
      idCookieEvolok:        config.cookie
    });
  }

  initialized = true;
  app.promised(READY_PROMISE_NS, config);

  // NOTE: If config.result !== '' mean the Media is Paywall On+
  if (config.result && config.result.length) {
    app.when(GIGYA_READY).then(authData => {
      if(authData.getUserType() === 'anonimo') {
        const userProducts = {};
        Notifier.init({authData, userProducts, config, app});
      } else {
        app.when(GIGYA_PRODUCTS_READY).then(userProducts => {
          Notifier.init({authData, userProducts, config, app});
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/paywall-autoload.js